export const LOCAL_STORAGE_USER_SLICE_KEY = 'USER_DATA_KEY';
export const LOCAL_STORAGE_LAST_USER_KEY = 'LAST_USER';
export const REFRESH_ACCESS_TOKEN_HEADER = 'X-IS-AUTH';
